module.exports = __webpack_public_path__ + "static/media/normal-noise-02.659fb5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/bump-maps/normal-noise-02.png
// module id = 49
// module chunks = 0